<template>
    <bottom-sheet v-model="shows" fullscreen persistent width="1224" maxWidth="100%">
        <template #activator="bind">
            <slot name="activator" v-bind="bind" />
        </template>
        <v-layout column justify-center class="bottom-sheet__contents h-100">
            <v-sheet style="flex: 1 1 auto; overflow-x: hidden; overflow-y: auto" class="scroll-primary pr-10">
                <vertical-form-table v-bind="{ items }"> 

                    <!--서명 완료 전-->
                    <template slot="계약서 서식" v-if="!value.isSigned">
                        <worker-form-page v-for="page in value.form.pages" :key="page.page" :value="{ ...value.form, page}"/>
                    </template>

                    <!--서명 완료 후-->
                    <template slot="계약서 서식" v-else>
                        <div ref="pdfArea" class="mt-12">
                            <!-- vuetify pdf 적용 (v-app 필요) -->
                            <v-app>
                                <worker-form-page v-for="page in value.form.pages" :key="page.page" :value="{ ...value.signedForm, page}"/>
                            </v-app>
                        </div>
                        <v-row justify="end">
                            <v-col cols="auto">
                                <v-btn small dark color="grey-d" outlined class="w-md-160px" @click="htmlToPdf">
                                    <span class="grey--text">PDF 다운로드</span> <v-icon size="18" color="grey" class="ml-4">mdi-tray-arrow-down</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </template>
                    //

                    <template slot="신분증사본">
                        <v-file-input v-model="identityCard" v-bind="attrs_input" disabled></v-file-input>
                        <v-row class="mt-3">
                            <v-col cols="auto">
                                <v-btn small dark color="grey-d" outlined class="w-md-120px" v-if="this.identityCard" :href="this.value?.signedForm?.identityCard" :download="this.identityCard.name">
                                    <span class="grey--text">다운로드</span>
                                </v-btn>
                            </v-col>
                            <v-col cols="auto">
                                <v-btn small dark color="grey-d" outlined class="w-md-120px" v-if="this.identityCard" :href="this.value?.signedForm?.identityCard" target="_blank">
                                    <span class="grey--text">미리보기</span>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </template>

                    <template slot="통장사본">
                        <v-file-input v-model="bankbook" v-bind="attrs_input" disabled></v-file-input>
                        <v-row class="mt-3">
                            <v-col cols="auto">
                                <v-btn small dark color="grey-d" outlined class="w-md-120px" v-if="this.bankbook" :href="this.value.signedForm.bankbook" :download="this.bankbook.name">
                                    <span class="grey--text">다운로드</span>
                                </v-btn>
                            </v-col>
                            <v-col cols="auto">
                                <v-btn small dark color="grey-d" outlined class="w-md-120px" v-if="this.identityCard" :href="this.value.signedForm.bankbook" target="_blank">
                                    <span class="grey--text">미리보기</span>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </template>
                </vertical-form-table>
            </v-sheet>
            <div class="v-btn-group flex-wrap">
                <v-btn color="primary" class="min-w-140px min-w-lg-160px" @click="shows = false"><span>확인</span></v-btn>
            </div>
            <v-fade-transition>
                <v-overlay v-show="loading" color="white">
                    <v-progress-circular size="100" width="5" color="primary" indeterminate />
                </v-overlay>
            </v-fade-transition>
        </v-layout>
    </bottom-sheet>
</template>

<script>
import html2Pdf from "html2pdf.js";

import api from '@/api';
import { attrs_input } from "@/assets/variables";

import BottomSheet from "@/components/dumb/bottom-sheet.vue";
import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";
import WorkerFormPage from './form/worker-form-page.vue';

const items = [
    {
        key: "",
        term: "계약서 서식",
    },
    {
        key: "identityCard",
        term: "신분증사본",
        type: "file",
        required: true,
    },
    {
        key: "bankbook",
        term: "통장사본",
        type: "file",
        required: true,
    },
].map((item) => ({ ...attrs_input, ...item }));

export default {
    components: {
        BottomSheet,
        VerticalFormTable,
        WorkerFormPage
    },
    props: {
        value: { type: Object, default: ()=>({}) }
    },
    data: () => ({
        loading: false,
        items,
        shows: false,
        attrs_input,

        bankbook: "",
        identityCard:""
    }),
    mounted(){
        if(this.value.isSigned) this.getSignedFiles()
    },
    methods:{
        async getSignedFiles(){
            const bankbook = await api.getResource(this.value.signedForm.bankbook, true);
            const identityCard = await api.getResource(this.value.signedForm.identityCard, true);

            this.bankbook = bankbook;
            this.identityCard= identityCard;

        },
        htmlToPdf(){
            const options = {
                     html2canvas: { scale: 2 },
                    filename: this.value.form.name + ".pdf",
                    jsPDF: { orientation: 'portrait', unit: 'px', format: [974,1379], compressPDF: true },
                    // jsPDF: { orientation: 'portrait', unit: 'px', format: [974,689], compressPDF: true },
                    margin: [0, 0, 0, 0], 
                    pagebreak: { mode: ['css'], before:"pdfImg" }
                    // maxPages: 3, // 최대 페이지 수
            };
            html2Pdf().set(options).from(this.$refs.pdfArea).save();
        }
    },
    watch:{
        shows(){
            this.$emit('show');
        }
    }
};
</script>

<style lang="scss" scoped>
</style>
